module.exports = __webpack_public_path__ + "static/media/MINI-TEST-COUNT-5.737c9e04.png";